import { motion } from "framer-motion";
import { TILES, CTA_URL, TIKTOK_URL } from "@/lib/copy";
import { Lock, ArrowUpRight, Instagram } from "lucide-react";
import TikTokIcon from "@/components/icons/TikTokIcon";

export default function Tiles() {
  return (
    <section
      className="relative bg-[var(--bg)] px-6 py-20 md:px-12 md:py-28"
      data-testid="tiles-section"
    >
      <div className="mx-auto max-w-[1440px]">
        <div className="mb-10 flex flex-col items-start gap-4 md:mb-14 md:flex-row md:items-end md:justify-between">
          <h2 className="font-serif text-4xl leading-[0.92] tracking-tighter text-white md:text-6xl">
            Uma prévia do que <span className="italic text-[var(--pink)]">te espera.</span>
          </h2>
          <p className="max-w-xs font-mono text-xs uppercase tracking-super text-white/50">
            Clique em qualquer foto pra desbloquear tudo
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6">
          {TILES.map((t, i) => (
            <motion.a
              key={i}
              href={CTA_URL}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.2, 0.9, 0.2, 1] }}
              className="group relative block aspect-[3/4] overflow-hidden"
              data-testid={`tile-${i + 1}`}
            >
              <img
                src={t.src}
                alt={t.label}
                className="spot-img h-full w-full object-cover"
                draggable={false}
                loading="lazy"
                decoding="async"
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
              <div className="pointer-events-none absolute inset-x-0 bottom-0 flex items-end justify-between p-4 md:p-6">
                <div>
                  <div className="font-mono text-[10px] uppercase tracking-super text-white/60">
                    0{i + 1} / 03
                  </div>
                  <div className="mt-1 font-serif text-2xl leading-tight text-white md:text-3xl">
                    {t.label}
                  </div>
                </div>
                <span className="flex items-center gap-1.5 border border-white/30 bg-black/40 px-2.5 py-1.5 font-mono text-[10px] uppercase tracking-super text-white backdrop-blur transition group-hover:border-[var(--pink)] group-hover:text-[var(--pink)]">
                  <Lock className="h-3 w-3" strokeWidth={2.4} />
                  ver
                </span>
              </div>
            </motion.a>
          ))}
        </div>

        {/* Repeat CTA */}
        <div className="mt-16 flex flex-col items-center gap-6 md:mt-20">
          <p className="max-w-xl text-center font-serif text-2xl leading-tight text-white/85 md:text-3xl">
            "O que você sempre quis ver está a{" "}
            <span className="italic text-[var(--pink)]">um clique</span> de distância."
          </p>
          <a
            href={CTA_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-magnetic"
            data-testid="tiles-cta-button"
          >
            <span>Quero acesso agora</span>
            <ArrowUpRight className="arrow h-4 w-4" strokeWidth={2.4} />
          </a>
          <a
            href="https://www.instagram.com/julssy__/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-ghost"
            data-testid="tiles-instagram-button"
          >
            <Instagram className="h-3.5 w-3.5" strokeWidth={2.2} />
            Me siga no Instagram
          </a>
          <a
            href={TIKTOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-ghost"
            data-testid="tiles-tiktok-button"
          >
            <TikTokIcon className="h-3.5 w-3.5" />
            Me siga no TikTok
          </a>
        </div>
      </div>
    </section>
  );
}
